import { render, staticRenderFns } from "./BuyGuideView.vue?vue&type=template&id=10aa08f1&scoped=true"
import script from "./BuyGuideView.vue?vue&type=script&lang=js"
export * from "./BuyGuideView.vue?vue&type=script&lang=js"
import style0 from "./BuyGuideView.vue?vue&type=style&index=0&id=10aa08f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aa08f1",
  null
  
)

export default component.exports